import { ReactComponent as ToTop } from "../assets/icons/toTop.svg";
import { useNavigate } from "react-router-dom";

const timeFormat = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const time = date.toLocaleTimeString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, { hour: '2-digit', minute: '2-digit' })
    return time + `${filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? " น." : ""}`
  }
}

const dateDayTimeFormat = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const dateTH = date.toLocaleDateString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, {
      year: '2-digit',
      month: 'short',
      day: filterLanguage === 'th-TH' ? 'numeric' : '2-digit',
    })
    const time = date.toLocaleTimeString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage)
    return dateTH + " " + time + (filterLanguage === 'th-TH' ? 'น.' : '')
  }
}

const dateDayTimeFormatAdmin = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const dateTH = date.toLocaleDateString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, {
      year: '2-digit',
      month: 'short',
      day: filterLanguage === 'th-TH' ? 'numeric' : '2-digit',
    })
    const time = date.toLocaleTimeString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, { hour: '2-digit', minute: '2-digit' })
    var hours = date.getHours();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    return `${filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? `${dateTH} ${time} น.` : `${filterLanguage === 'th-TH' ? `${dateTH} ${time} น.` : `${dateTH} ${time} ${ampm}`}`}`
  }
}

const dateDayFormatAdmin = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const dateTH = date.toLocaleDateString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, {
      year: '2-digit',
      month: 'short',
      day: filterLanguage === 'th-TH' ? 'numeric' : '2-digit',
    })
    return dateTH
  }
}

const dateMonthFormatAdmin = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const dateTH = date.toLocaleDateString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, {
      year: '2-digit',
      month: 'short',
    })
    return dateTH
  }
}

const dateTimeFormat = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const time = date.toLocaleTimeString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, { hour: '2-digit', minute: '2-digit' })
    return `${filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? `${time} น.` : `${filterLanguage === 'th-TH' ? `${time} น.` : `${time}`}`}`
  }
}

const dateDayFormat = (data) => {
  const language = localStorage.getItem("lang");
  const filterLanguage = language === 'th-TH' ? 'th-TH' : language === "en-US" ? "en-GB" : language
  if (data !== undefined && data !== null && data !== "") {
    const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
    const dateTH = date.toLocaleDateString(filterLanguage === undefined || filterLanguage === null || filterLanguage === "" ? 'th-TH' : filterLanguage, {
      year: '2-digit',
      month: 'short',
      day: filterLanguage === 'th-TH' ? 'numeric' : '2-digit',
    })
    return dateTH
  }
}

const formatDate = (date) => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;
  return [year, month, day].join('-');
}

const formatTime = (date) => {
  var d = new Date(date),
    hours = '' + d.getHours(),
    minutes = '' + d.getMinutes(),
    seconds = d.getSeconds();

  if (hours.length < 2)
    hours = '0' + hours;
  if (minutes.length < 2)
    minutes = '0' + minutes;
  if (seconds.length < 2)
    seconds = '0' + seconds;
  return [hours, minutes, seconds].join(':');
}

const formatDate2 = (date) => {
  if (date !== undefined && date !== null && date !== "") {
    var d = new Date(date.replace(/-/g, "/").replace(/T/g, " ")),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    let joinDate = [day, month, year].join('/');
    if (joinDate !== 'NaN/NaN/NaN') {
      return joinDate;
    } else {
      return "";
    }
  }
  else {
    return "";
  }
}

const formatDate3 = (date, lang = "") => {
  const language = lang === "" ? localStorage.getItem("lang") : lang === "en-US" ? "en-GB" : lang;
  return new Date(date).toLocaleString(language === undefined || language === null || language === "" ? 'th-TH' : language, {
    year: "2-digit",
    month: "short",
    day: "numeric",
  })
}

const formatDate4 = (date, lang = "") => {
  const language = lang === "" ? localStorage.getItem("lang") : lang === "en-US" ? "en-GB" : lang;
  return new Date(date).toLocaleString(language === undefined || language === null || language === "" ? 'th-TH' : language, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })
}

const formatDateFull = (date, lang = "") => {
  const language = lang === "" ? localStorage.getItem("lang") : lang === "en-US" ? "en-GB" : lang;
  return new Date(date).toLocaleString(language === undefined || language === null || language === "" ? 'th-TH' : language, {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}


const formatDateForJourney = (date) => {
  if (date !== undefined && date !== null && date !== "") {
    var d = new Date(date.replace(/-/g, "/").replace(/T/g, " ")),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    let joinDate = [day, month, year].join('/');
    if (joinDate !== 'NaN/NaN/NaN') {
      return joinDate;
    } else {
      return "";
    }
  }
  else {
    return "";
  }
}

const subStractDate = (date, type, number) => {
  const tmpDate = new Date(date);
  if (type === "add") {
    tmpDate.setDate(tmpDate.getDate() + number);
  } else if (type === "minus") {
    tmpDate.setDate(tmpDate.getDate() - number);
  }
  return tmpDate
}

const isEllipsisActive = (e) => {
  return (e.offsetWidth < e.scrollWidth);
}

const StepStatusColor = (data) => {
  let result = "gray"
  if (data.mark !== "requester") {
    if (data.status === "wait") {
      result = "pending"
    } else if (data.status === "verify" || data.status === "approve" || data.status === "approved") {
      result = "completed"
    } else if (data.status === "rejected" || data.status === "reject") {
      result = "red"
    }
  } else {
    if (data.status !== "cancel") {
      if (data.type === "approve") {
        if (data.status !== 'wait') result = "completed"
        else result = 'pending'
      } else {
        result = "red"
      }
    }
  }
  return result
}

const mapDateNumberToName = (data) => {
  let result = "gray"
  if (data.mark !== "requester") {
    if (data.status === "wait") {
      result = "pending"
    } else if (data.status === "verify" || data.status === "approve" || data.status === "approved") {
      result = "completed"
    } else if (data.status === "rejected" || data.status === "reject") {
      result = "red"
    }
  } else {
    if (data.status !== "cancel") {
      if (data.type === "approve") {
        result = "completed"
      } else {
        result = "red"
      }
    }
  }
  return result
}

const capitalizedString = (string) => {
  return string[0].toUpperCase() + string.substr(1).toLowerCase()
}

const formatData = (data, defaults) => {
  if (data !== null && data !== undefined && data !== "") {
    return data;
  }
  return defaults;
}

const upperFirstWord = (str) => {
  if (str) {
    var splitStr = str.toString().toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
}

const ScrollToTop = () => {
  const handleClick = event => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div onClick={handleClick} style={{ position: "fixed", height: "40px", width: "40px", borderRadius: "50%", background: "#5DA196", boxShadow: "0px 4px 4px rgb(0 0 0 / 10%)", bottom: "34px", right: "34px", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "9999" }} role="presentation">
      <ToTop />
    </div>
  );
}

let formatpath = (data) => {
  let getSite = "iamconsulting"
  if (data !== undefined && data !== "undefined" && data !== null && data !== "null" && data !== "") {
    return data;
  }
  return getSite;
}

function testJSON(strJson) {
  try {
    const parsed = JSON.parse(strJson)
    if (parsed && typeof parsed === "object") {
      return true
    }
  } catch { return false }
  return false
}

function urlify(text) {
  if (text && text !== '') {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
      return '<a href="' + url + '" target="_blank">' + url + '</a>';
    })
  } else return ''
}

function switchDate(targetValue) {
  let target = targetValue;
  if (targetValue && targetValue.indexOf('/') > 0) {
    var splitValue = target.split('/')
    target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
  }
  return target;
}

function showDateField(targetValue) {
  let target = targetValue;
  if (targetValue && targetValue.indexOf('/') > 0) {
    var splitValue = target.split('/')
    target = splitValue[2] + "-" + splitValue[1] + "-" + splitValue[0]
  }
  return target;
}

const formatExpDate = (value) => {
  let formatted = value.split('y').join(',').split('m').join(',').split('d').join(',').split(',')
  return `${formatted?.[0] ?? 0}y ${formatted?.[1] ?? 0}m ${formatted?.[2] ?? 0}d`
}

const toTimestamp = (strDate) => {
  if (strDate !== "" && strDate !== null && strDate !== undefined) {
    const dt = Date.parse(strDate);
    return dt / 1000;
  } else {
    return 0;
  }
}

const splitString = (str) => {
  return str?.toString()?.split(" ")
}

export {
  formatpath, timeFormat, formatTime, dateDayTimeFormat, dateMonthFormatAdmin,
  dateDayTimeFormatAdmin, formatData, dateDayFormatAdmin, dateDayFormat, dateTimeFormat,
  isEllipsisActive, StepStatusColor, mapDateNumberToName, formatDate, formatDate2,
  formatDate3, formatDate4, formatDateForJourney, subStractDate, capitalizedString,
  upperFirstWord, ScrollToTop, testJSON, formatDateFull, urlify,
  switchDate, showDateField, formatExpDate, toTimestamp, splitString
}
